import restApi from "@plannel/services/utils/rest-api";

/*
 * Sales Plan Accuracy Dashboard(판매계획 정확도) 데이터 서비스.
 * 독립 DW 기반 백엔드 조회 — **목업 없음, 전부 실데이터**.
 *   백엔드: GET /api/dashboard-dw/sales-plan-accuracy (SalesPlanAccuracyDashboardController)
 *   소스: z_fact_dp_demand(FF/SF/MF/BF 계획) ⋈ z_fact_sales_actual(실적)
 *         — (품목, 거래처, 월) FULL OUTER JOIN. 계획 없이 팔린 것/계획했는데 안 팔린 것도 살린다.
 *   산식·컬럼 명세: saas-application/docs/sql/dw/dashboard-spec/04_sales_plan_accuracy.md
 *
 * params: { currentDate?, itemLevel?, custLevel?, itemNode?, itemNodeLv?, custNode?, custNodeLv? }
 *   itemNode/custNode = 계층 트리에서 고른 노드 코드 + 그 노드의 레벨(itemNodeLv/custNodeLv). 비면 전체.
 *   ★ 집계 레벨(itemLevel/custLevel)과 무관하다 — 트리에서 고른 지점이 곧 필터 레벨이다.
 *   ★ 필터는 **페이지 전체**에 걸린다 — 서버가 combo 를 만들 때 한 번 적용하므로 모든 카드가 같은 범위다.
 *   ★ 단위(AMT/QTY)는 재조회 대상이 아니다 — 응답에 두 벌이 다 들어 있어 프런트가 토글만 한다.
 *
 * 응답 envelope: { currencyCd, period, chartPeriod, availableBuckets,
 *                  itemLevels, itemLevel, custLevels, custLevel,
 *                  itemTree, itemNode, itemNodeLv, custTree, custNode, custNodeLv,
 *                  kpis, spark, trend:{AMT,QTY}, accuracyByStage[],
 *                  attainDist:{AMT,QTY}, deviationTop:{AMT,QTY}, detailGrid:{months,AMT,QTY} }
 *
 * 창이 두 개다: period = KPI 창(완료 12개월, 당월 제외), chartPeriod = 차트 창(16개월, 미래 3개월 포함).
 * 완료 월이 아닌 구간의 달성률·정확도는 **null** 로 온다(0 이 아니다 — 0 은 "달성률 0%" 로 읽힌다).
 */
const get = (params) => restApi.get("/api/dashboard-dw/sales-plan-accuracy", { params });

const salesPlanAccuracyService = { get };

export default salesPlanAccuracyService;
